/** Session row height in pixels — virtualizer estimate and rendered row share this value. */
export const WORKSPACE_AGENT_MY_TASKS_ROW_HEIGHT = 75;

/**
 * Automation list rows (prototype `AgentWorkflowRow` for automation definitions): title + meta only, no preview.
 */
export const WORKSPACE_AGENT_MY_TASKS_COMPACT_ROW_HEIGHT = 44;

/** Vertical gap between session rows (`gap-1`). */
export const WORKSPACE_AGENT_MY_TASKS_ROW_GAP = 4;

export const WORKSPACE_AGENT_MY_TASKS_ROW_TOTAL_HEIGHT =
  WORKSPACE_AGENT_MY_TASKS_ROW_HEIGHT + WORKSPACE_AGENT_MY_TASKS_ROW_GAP;

export const WORKSPACE_AGENT_MY_TASKS_COMPACT_ROW_TOTAL_HEIGHT =
  WORKSPACE_AGENT_MY_TASKS_COMPACT_ROW_HEIGHT + WORKSPACE_AGENT_MY_TASKS_ROW_GAP;

/** First section header (no inter-section gap). */
export const WORKSPACE_AGENT_MY_TASKS_SECTION_HEADER_HEIGHT = 26;

/** Subsequent section headers include `pt-5` (20px) above the label. */
export const WORKSPACE_AGENT_MY_TASKS_SECTION_HEADER_WITH_GAP_HEIGHT = 46;

export const WORKSPACE_AGENT_MY_TASKS_LOAD_MORE_ROW_HEIGHT = 48;

/** Fetch the next page when the last visible row is within this many rows of the end. */
export const WORKSPACE_AGENT_MY_TASKS_FETCH_NEXT_PAGE_ROW_THRESHOLD = 3;
